// extracted by mini-css-extract-plugin
export default {"root":"ThreadVideoPayer_root__qSFyH"};